const green = {
  100: '#00DD9B',
  50: '#80EECD',
  30: '#B3F5E1',
  10: '#E5FCF5',
};
export default green;
